import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, IconButton, Avatar, Button, CircularProgress } from '@mui/material';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ShareIcon from '@mui/icons-material/Share';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import RepeatOutlinedIcon from '@mui/icons-material/RepeatOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { req } from '../../ServerUtils';

export const timeAgo = (dateString) => {
    const now = new Date();
    const date = new Date(dateString);
    const seconds = Math.floor((now - date) / 1000);
    
    const minutes = Math.floor(seconds / 60); // Calculate minutes
    const hours = Math.floor(seconds / 3600); // Calculate hours
    const days = Math.floor(seconds / 86400); // Calculate days
    const months = Math.floor(days / 30); // Calculate months
    const years = Math.floor(days / 365); // Calculate years

    if (seconds < 60) {
        return seconds === 1 ? `${seconds} second ago` : `${seconds} seconds ago`; // Singular/plural for seconds
    } else if (minutes < 60) {
        return minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`; // Singular/plural for minutes
    } else if (hours < 24) {
        return hours === 1 ? `${hours} hour ago` : `${hours} hours ago`; // Singular/plural for hours
    } else if (days < 30) {
        return days === 1 ? `${days} day ago` : `${days} days ago`; // Singular/plural for days
    } else if (months < 12) {
        return months === 1 ? `${months} month ago` : `${months} months ago`; // Singular/plural for months
    } else {
        return years === 1 ? `${years} year ago` : `${years} years ago`; // Singular/plural for years
    }
};
const Post = ({ post }) => {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [showFullText, setShowFullText] = useState(false);
    const [lines, setLines] = useState(post.content.split('\n'));


    const renderText = (text) => {
        if (text.length <= 140 || showFullText) {
            return lines.map((line, index) => (
                <p key={index}>{line}</p>
            ));
        }
        return (
            <>
                {text.substring(0, 140)}...{' '}
                <Button 
                    onClick={() => setShowFullText(true)}
                    sx={{ 
                        p: 0, 
                        minWidth: 'auto',
                        textTransform: 'none',
                        color: '#1976d2',
                        fontSize: '14px',
                        '&:hover': {
                            background: 'none',
                            textDecoration: 'underline'
                        }
                    }}
                >
                    See more
                </Button>
            </>
        );
    };

    const handleNextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % Math.ceil(post.images.length / 2));
    };

    const handlePrevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + Math.ceil(post.images.length / 2)) % Math.ceil(post.images.length / 2));
    };

    return (
        <div style={{ display: 'flex' }}>
            <Box sx={{ display: 'flex', alignItems: 'end', mb: 2 }}>
                <Avatar sx={{ width: 32, height: 32, mr: 1, backgroundColor: '#8e60fe' }}>
                    {post.name && post.name.length > 0 ? post.name[0] : 'U'} {/* Fallback to 'U' if user is undefined */}
                </Avatar>
            </Box>
            <Card sx={{ 
                minWidth: 600, 
                mb: 2, 
                borderRadius: '12px',
                boxShadow: 'none',
                border: '1px solid #e0e0e0',
                backgroundColor: '#F9FAFB'
            }}>
                <Box sx={{ p: 2 }}>
                    {post.content && (
                        <Typography sx={{ fontSize: '16px', color: '#666', mb: 1 }}>
                            
                            {renderText(post.content)}
                            
                        </Typography>
                    )}
                  
                </Box>

                {post.post_type.toLowerCase() === 'carousel' && post.images.length > 1 && (
                    <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <IconButton 
                            sx={{ position: 'absolute', left: '1%', top: '50%', transform: 'translateY(-50%)', bgcolor: 'white', boxShadow: '2px 6px 6px 2px lightgray', zIndex: '10' }}
                            onClick={handlePrevSlide}
                            disabled={currentSlide === 0}
                        >
                            <KeyboardArrowLeftIcon />
                        </IconButton>
                        <IconButton 
                            sx={{ position: 'absolute', right: '1%', top: '50%', transform: 'translateY(-50%)', bgcolor: 'white', boxShadow: '2px 6px 6px 2px lightgray', zIndex: '10' }}
                            onClick={handleNextSlide}
                            disabled={currentSlide >= Math.ceil(post.images.length / 2) - 1}
                        >
                            <KeyboardArrowRightIcon />
                        </IconButton>
                        <Box sx={{ 
                            width: '80%', 
                            height: 200, 
                            overflow: 'hidden',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: '8px',
                            padding: '10px'
                        }}>
                            <Box sx={{ 
                                display: 'flex', 
                                transition: 'transform 0.5s ease', 
                                transform: `translateX(-${currentSlide * 100}%)`,
                                width: `${Math.max(post.images.length, 2) * 100}%` // Adjust width based on number of images
                            }}>
                                {post.images.map((image, index) => (
                                    <Box key={index} sx={{ width: '46%', flexShrink: 0, padding: '0 10px' }}>
                                        <img 
                                            src={image} 
                                            alt={post.title}
                                            style={{ 
                                                width: '100%', 
                                                height: '100%', 
                                                objectFit: 'cover',
                                                border: '5px solid white', // White border
                                                borderRadius: '8px' // Rounded corners
                                            }}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                )}

                {post.post_type === 'Image' && (
                    <Box sx={{ 
                        width: '50%', 
                        minHeight: 200, 
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        borderRadius: '8px',
                        padding: '10px',
                        margin: 'auto'
                    }}>
                        <img 
                            src={post.images[0]} 
                            alt={post.title}
                            style={{ 
                                width: '100%', 
                                height: '100%', 
                                objectFit: 'cover',
                                border: '5px solid white', // White border
                                boxShadow: '0 4px 10px rgba(155, 142, 142, 0.2)',
                                borderRadius: '8px' // Rounded corners
                            }}
                        />
                    </Box>
                )}

                <Box sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, backgroundColor: '#E5E7EB', padding: '10px', borderRadius: '10px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <ThumbUpOutlinedIcon sx={{ fontSize: 20, mr: 0.5 }} />
                            <Typography sx={{ fontSize: '14px' }}>{post.likes}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <ChatBubbleOutlineIcon sx={{ fontSize: 20, mr: 0.5 }} />
                            <Typography sx={{ fontSize: '14px' }}>{post.comments}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <RepeatOutlinedIcon sx={{ fontSize: 20, mr: 0.5 }} />
                            <Typography sx={{ fontSize: '14px' }}>{post.shares}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {post.created_at && <AccessTimeOutlinedIcon sx={{ fontSize: 20, mr: 0.5 }} />}
                            <Typography sx={{ fontSize: '14px' }}>{post.created_at ? timeAgo(post.created_at) : ''}</Typography>
                        </Box>
                        {/* <Box sx={{ ml: 'auto' }}>
                            <IconButton size="small">
                                <ShareIcon sx={{ fontSize: 20 }} />
                            </IconButton>
                            <IconButton size="small">
                                <BookmarkBorderIcon sx={{ fontSize: 20 }} />
                            </IconButton>
                        </Box> */}
                    </Box>
                </Box>
            </Card>
        </div>
    );
};

const PostsFeed = ({ searchParams }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [page, setPage] = useState(0);
    const [total, setTotal] = useState(0); // this is total pages

    const camelToSnake = (str) => {
        return str.replace(/([A-Z])/g, '_$1').toLowerCase();
    };

    function refresh() {
        let q = '';
        for (const key in searchParams) {
            if (searchParams[key] !== undefined) {
                if (searchParams[key] === 'undefined') {
                    q += `${camelToSnake(key)}=${''}&`;
                } else {
                    q += `${camelToSnake(key)}=${searchParams[key]}&`;
                }
            }
        }
        req(`/linkedin-posts/search?${q}&page=${page+1}&page_size=20`, 'GET', null, true, 'https://api.ideakart.in').then(res => {
            setPosts([...posts, ...res.results]);
            setPage(res.page);
            setTotal(res.total);
            setLoading(false);
        }).catch(err => {
            setError('Error fetching posts');
        }).finally(() => {
            setLoading(false);
        });
    }

    useEffect(() => {
        setPosts([]);
        setPage(0);
        setTotal(0);
        refresh();
    }, [searchParams]); 

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Typography color="error" variant="h6" align="center">
                {error}
            </Typography>
        );
    }

    return (
        <Box sx={{ p: 2 }}>
            {posts.map((post, index) => (
                <Post key={index} post={post} />
            ))}

            {page < total && (
                <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <Button variant="contained" style={{textTransform: "none"}} onClick={() => {
                        refresh();
                    }}>Load More</Button>
                </div>
            )}
        </Box>
    );
};

export default PostsFeed;